'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { type PropsWithChildren, useEffect, useRef } from 'react';
import { FocusScope, Overlay, useModalOverlay } from 'react-aria';
import { type OverlayTriggerState } from 'react-stately';
import { Button } from '@module/mdrt-org/shared/components/button/button';
import { ButtonVariant } from '@shared/ui-components/button/buttonVariant';
import { DrawerClose } from '@shared/ui-components/svgs';
import { useGlobalCmsContentContext } from '../providers/global-cms-context';
import styles from './drawer.module.scss';
type DrawerProps = {
  className?: string;
  state: OverlayTriggerState;
};
export const Drawer = t0 => {
  const $ = _c(27);
  let children;
  let className;
  let restProps;
  let state;
  if ($[0] !== t0) {
    ({
      children,
      className,
      state,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = restProps;
    $[4] = state;
  } else {
    children = $[1];
    className = $[2];
    restProps = $[3];
    state = $[4];
  }
  const {
    cmsContent
  } = useGlobalCmsContentContext();
  const drawerRef = useRef(null);
  const drawerWrapperRef = useRef(null);
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      isDismissable: true
    };
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    modalProps,
    underlayProps
  } = useModalOverlay(t1, state, drawerRef);
  let t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const handleTouchStart = event => {
        const touchTarget = event.target as HTMLElement;
        if (!drawerRef.current?.contains(touchTarget)) {
          event.preventDefault();
        }
      };
      const drawerElementWrapper = drawerWrapperRef.current;
      if (drawerElementWrapper) {
        drawerElementWrapper.addEventListener("touchstart", handleTouchStart);
      }
      return () => {
        if (drawerElementWrapper) {
          drawerElementWrapper.removeEventListener("touchstart", handleTouchStart);
        }
      };
    };
    t3 = [];
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== className) {
    t4 = classNames(styles.drawer, className);
    $[8] = className;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== state) {
    t5 = () => state.close();
    $[10] = state;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DrawerClose />;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== cmsContent.closeButtonLabel || $[14] !== t5) {
    t7 = <div className={styles.drawer__actions}><Button aria-label={cmsContent.closeButtonLabel} className={styles["drawer__close-button"]} onClick={t5} variant={ButtonVariant.Plain}>{t6}</Button></div>;
    $[13] = cmsContent.closeButtonLabel;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== children || $[17] !== modalProps || $[18] !== t4 || $[19] !== t7) {
    t8 = <FocusScope autoFocus={true} contain={true} restoreFocus={true}><div className={t4} ref={drawerRef} {...modalProps}>{t7}{children}</div></FocusScope>;
    $[16] = children;
    $[17] = modalProps;
    $[18] = t4;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== restProps || $[22] !== t8) {
    t9 = <div className={styles["drawer-wrapper"]} ref={drawerWrapperRef} {...restProps}>{t8}</div>;
    $[21] = restProps;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t9 || $[25] !== underlayProps) {
    t10 = <Overlay {...underlayProps}>{t9}</Overlay>;
    $[24] = t9;
    $[25] = underlayProps;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};